import "./MySubscription.css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Icons from "../../../../../Config/Images";
import Footer from "../../../Layout/Footer/Footer";
import { useDispatch } from "react-redux";
import {
  getActiveSubscriptionAPI,
  getSubscriptionAPI,
} from "../../../../../Store/Action/subscriptionAction";
import { PlanCard } from "..";
import Header from "../../../Layout/Header/Header";
import "./MySubscription.css";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";

const MySubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeSubscriptionData, setActiveSubscriptionData] = useState([]);
  const [upgradeSubscriptionData, setUpgradeSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(
      getActiveSubscriptionAPI({}, (result) => {
        setActiveSubscriptionData(result || []); // Make sure activeSubscriptionData is an array
        setLoading(false);
      })
    );
  }, []);

  // Fetch all subscription plans and filter for upgrade options
  useEffect(() => {
    if (activeSubscriptionData?.length > 0) {
      setLoading(true);

      dispatch(
        getSubscriptionAPI({}, (result) => {
          // Extract active subscription IDs and their prices
          const activeSubscriptionIds = activeSubscriptionData?.map(
            (plan) => plan.user_subscription_plan_id
          );
          const activeSubscriptionPrices = activeSubscriptionData?.map(
            (plan) => plan.user_subscription_plan_price
          );

          // activeSubscriptionPrices.some((price) => console.log(price));
          // Filter plans for upgrades (exclude active subscription IDs and check for a higher price)
          const filteredPlans = result?.data?.filter(
            (plan) =>
              !activeSubscriptionIds.includes(
                plan?.user_subscription_plan_id
              ) &&
              activeSubscriptionPrices.some(
                (price) => Number(plan?.user_subscription_plan_price) > price
              )
          );

          setUpgradeSubscriptionData(filteredPlans || []);
          setLoading(false);
        })
      );
    }
  }, [activeSubscriptionData, dispatch]);
  // Format date as dd/MM/yyyy
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // Formats to day/month/year
  };

  const handleChangeToUpgradePlan = () => {
    navigate("/subscriptionPlan");
  };
  return (
    <>
      <Header />
      <div className="my-subscription-div">
        <div className="account-header">
          <p className="ac-header-para">My Subscription </p>
        </div>

        <div className="divider" />
        {loading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : (
          <>
            <div className="active-plan-div">
              <div className="active-plan-one-div">
                <div className="active-plan">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <h3 className="active-p-h3">Active Plan</h3>

                    {/* Render active subscription data if available */}
                    {activeSubscriptionData.length > 0 ? (
                      activeSubscriptionData.map((e) => (
                        <PlanCard
                          key={e?.user_subscription_plan_type_name} // Add a key for each PlanCard
                          name={e?.user_subscription_plan_type_name}
                          description={e?.user_subscription_plan_description}
                          price={`₹${e?.user_subscription_plan_price}`}
                          duration={e?.user_subscription_plan_duration_months}
                          benefits={e?.features || []} // Pass benefits
                          activePlanScreen={true}
                        />
                      ))
                    ) : (
                      <p>No active subscriptions available.</p>
                    )}

                    {/* <p className="validity-para">
                      Valid up to:{" "}
                      {formatDate(
                        activeSubscriptionData[0]
                          ?.user_subscription_plan_valid_till
                      )}
                    </p> */}
                  </div>
                </div>
              </div>
              {/* <div className="active-plan-sec-div">
        
                <div className="vertical-line" />
              </div>
              <div className="active-plan-third-div">
                <div className="upgrade-plan">
                 
                  <div className="upgrade-plan-inner-div">
                    <h3
                      style={{ marginBottom: "10px" }}
                      className="upgrade-p-h3"
                    >
                      Upgrade Plan
                    </h3>

                    <div className="plan-card-individual-div">
                    
                      {upgradeSubscriptionData.length > 0 ? (
                        upgradeSubscriptionData.map((e) => (
                          <PlanCard
                            key={e?.user_subscription_plan_type_name} // Add a key for each PlanCard
                            name={e?.user_subscription_plan_type_name}
                            description={e?.user_subscription_plan_description}
                            price={`₹${e?.user_subscription_plan_price}`}
                            duration={e?.user_subscription_plan_duration_months}
                            benefits={e?.features || []} // Pass benefits
                            activePlanScreen={true}
                          />
                        ))
                      ) : (
                        <p>No Upgrade subscriptions available.</p>
                      )}
                    </div>
                  </div>
                  {upgradeSubscriptionData?.length > 0 ? (
                    <div className="upgrade-plan-change-div">
                      <button onClick={handleChangeToUpgradePlan}>
                        Change Plan
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div> */}

          
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MySubscription;
